<template>
  <div
    :style="{
      textAlign: textAlign,
      width: width + '%',
      margin,
      position: 'relative'
    }"
  >
    <p v-if="errorMessage" class="red--text field-error">{{ errorMessage }}</p>
    <label :style="[labelStyles]">{{ labelTitle }}</label>
    <span v-if="required" class="pink--text">*</span>
    <div v-if="unit && unitFirst" class="input-unit-head">
      <span>{{ unit.toUpperCase() }}</span>
    </div>
    <div v-if="unitIcon && unitFirst" class="input-unit-head">
      <span
        class="icon"
        :style="{
          backgroundImage: `url(${require(`@/assets/icons/${unitIcon}.svg`)})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: '100%'
        }"
      ></span>
    </div>
    <input
      v-on:input="$emit('input', $event.target.value)"
      autocomplete="off"
      :placeholder="placeholder"
      :required="required"
      :disabled="disabled"
      :max="maxDate != null ? maxDate : null"
      :step="step"
      :type="type === 'password' ? (showPassword ? 'input' : 'password') : type"
      :value="value"
      :style="[
        unit || unitIcon
          ? unitFirst
            ? {
                height: height + 'px',
                paddingLeft: '3rem'
              }
            : {
                height: height + 'px',
                paddingRight: '5rem'
              }
          : {
              height: height + 'px'
            },
        inputStyles
      ]"
    />
    <div
      v-if="type === 'password'"
      @click="showPassword = !showPassword"
      class="input-unit-end"
    >
      <img
        class="eye-icon"
        :src="
          require('@/assets/icons/eye-' +
            (showPassword ? 'blue' : 'pink') +
            '.svg')
        "
      />
    </div>
    <div v-if="unit && !unitFirst" class="input-unit-end">
      <span>{{ unit.toUpperCase() }}</span>
    </div>
    <div v-if="unitIcon && !unitFirst" class="input-unit-end">
      <span
        class="icon"
        :style="{
          backgroundImage: `url(${require(`@/assets/icons/${unitIcon}.svg`)})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: '100%'
        }"
      ></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "InputField",
  props: {
    maxDate: { default: null },
    value: {},
    labelTitle: {},
    errorMessage: { default: null },
    required: Boolean,
    disabled: Boolean,
    placeholder: { default: "" },
    type: { default: "text" },
    textAlign: { default: "left" },
    height: { default: 40 },
    width: { default: 90 },
    margin: { default: "0px auto" },
    unit: { default: null },
    unitIcon: { default: null },
    unitFirst: Boolean,
    step: { default: 1 },
    inputStyles: {},
    labelStyles: {},
  },
  data: function() {
    return {
      showPassword: false
    };
  }
};
</script>

<style scoped>
/* CSS specific to iOS devices */
@supports (-webkit-overflow-scrolling: touch) {
  input::placeholder {
    line-height: 14px;
  }
}

input {
  display: block;
  background: transparent;
  width: 100%;
  padding: 0 1rem;
  margin-top: 0.7rem;
  border: 1px solid #e05484;
  box-sizing: border-box;
  border-radius: 25.5px;
  /* outline: none; */
}

input::placeholder {
  color: #8a8a8a;
  font-family: "OpenSans";
  font-size: 14px;
}

.field-error {
  margin: 0 0 6px 0;
}

input:disabled {
  background-color: #dddddd;
}

.input-unit-head {
  position: absolute;
  bottom: 0;
  display: block;
  left: 0.5rem;
  height: 40px;
  text-align: center;
  width: 32px;
  line-height: 40px;
  border-right: 1px solid #e05484;
  color: #e05484;
}

.input-unit-end {
  position: absolute;
  bottom: 0;
  display: block;
  right: 0.5rem;
  height: 40px;
  text-align: center;
  width: 64px;
  line-height: 40px;
  border-left: 1px solid #e05484;
  color: #e05484;
}

.icon {
  display: block;
  height: 100%;
}

.eye-icon {
  height: 100%;
  width: auto;
}
</style>
